const T = require("react").PropTypes;

function Spec(formName, data) {
    this.FormName = formName;
    this.Data = data;
}

const MetadataSpec = {
    Type: T.shape({
        FormName: T.string.isRequired,
        Data: T.shape({
            IsComplete: T.bool,
            Arg: T.string
        })
    }),
    MakeSpec(formName, data) {
        return new Spec(formName, data);
    }
};

module.exports = MetadataSpec;


// WEBPACK FOOTER //
// ./src/types/MetadataSpec.js